import { RadioGroupOptionItem } from 'components/Popover';
import { Option } from 'components/RadioOptions';
import {
  GenerateProjectNameFormality,
  GenerateProjectNameTone,
} from 'redux/middleware/api/creation-service/types';

export const FORMALITY_OPTIONS: Option<GenerateProjectNameFormality>[] = [
  {
    label: 'Neutral',
    value: 'neutral',
  },
  {
    label: 'Casual',
    value: 'casual',
  },
  {
    label: 'Formal',
    value: 'formal',
  },
];

export const TONE_OPTIONS: Option<GenerateProjectNameTone>[] = [
  {
    label: 'Direct',
    value: 'direct',
  },
  {
    label: 'Empathetic',
    value: 'empathetic',
  },
  {
    label: 'Witty',
    value: 'witty',
  },
];

export const REGENERATE_TEXT_OPTIONS: RadioGroupOptionItem<
  GenerateProjectNameFormality | GenerateProjectNameTone
>[] = [
  {
    id: 'formality',
    label: 'formality',
    options: FORMALITY_OPTIONS,
  },
  {
    id: 'tone',
    label: 'tone',
    options: TONE_OPTIONS,
  },
];
